import { getMessageForErrorCode } from "../constants/authErrorCodes";

// Central auth-error handler. Any API caller that receives a response with a
// recognised `error_code` (DEVICE_CHANGE_REQUIRED / SESSION_SUPERSEDED /
// ACCESS_DISABLED_*) should call this. It clears client-side auth state,
// notifies the user, and redirects to `/`. The device_id zombie cookie is
// intentionally left intact — it identifies the browser, not the user.

let handlingAuthError = false;
let logoutInProgress = false;

// Call before an intentional logout. While set, SESSION_SUPERSEDED responses
// triggered by any in-flight/periodic request riding the stale token are
// treated as handled — no alert, no redirect — because the user already
// knows they're signing out.
export function beginLogout() {
    logoutInProgress = true;
}

export default function handleAuthErrorResponse(json) {
    if (!json || !json.error_code) return false;
    // Prefer the backend-provided message (platform-aware) over the local map.
    const message = json.message || getMessageForErrorCode(json.error_code);
    if (!message) return false;
    if (logoutInProgress) return true;
    if (handlingAuthError) return true;
    handlingAuthError = true;

    try {
        window.sessionStorage.removeItem("token");
        window.localStorage.removeItem("temp-token");
        window.localStorage.removeItem("user_id");
        window.localStorage.removeItem("x-token");
    } catch (e) { }

    try {
        // eslint-disable-next-line no-alert
        window.alert(message);
    } catch (e) { }

    window.location.href = "/";
    return true;
}
